// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.EditRentAmountChangeWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { EditRentAmountChangeWebApiRequestDto } from '../..';

export const EditRentAmountChangeWebApiHandler_editRentAmountChange_Path = '/api/web/v1/editRentAmountChange';

/**
 * Edit a pending rent amount change for a landlord property
 */
export const EditRentAmountChangeWebApiHandler_editRentAmountChange = (
  postData: EditRentAmountChangeWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, EditRentAmountChangeWebApiRequestDto, void>(
    {
      endpoint: EditRentAmountChangeWebApiHandler_editRentAmountChange_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
